import { environment } from '@environments/environment';

export const GET_STORE_SCHEDULE_QUERY = (langcode: string, storeUuid: string) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_store ?? '',
  body: {
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
          {
            term: {
              uuid: storeUuid,
            },
          },
        ],
      },
    },
    _source: ['weekly_opening_hours', 'exceptional_openings', 'exceptional_closures', 'operational_status'],
    size: 1,
  },
});
